/** @jsxImportSource @emotion/react */
import { SerializedStyles, css } from "@emotion/react";
import React from "react";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  additionalStyles?: SerializedStyles;
}

export const CardBody = ({ children, additionalStyles, ...rest }: Props) => {
  const bodyWrapperStyle = css`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-left: 24px;
    padding-right: 24px;
    gap: 8px;
    ${additionalStyles}
  `;

  return (
    <div css={bodyWrapperStyle} {...rest}>
      {children}
    </div>
  );
};
